import type { GetServerSideProps } from 'next';
import type { ResearchConditionsPageProps } from 'lib/queries/conditions';
import type { Blocks as BlocksType } from 'types';
import { Wrap } from '@leafwell/components';
import PageWrap from 'components/page-wrap';
import ArticleJson from 'components/structured-data/article';
import { getResearchConditionsPage } from 'lib/queries/conditions';
import HeroResearch from 'components/hero-research';
//import ConditionsByType from 'components/conditions-by-type';
import Blocks from 'components/blocks';
//import Line from 'components/line';
import Archive from 'components/archive';

export const getServerSideProps = (async context => {
  context.res.setHeader(
    'Cache-Control',
    'public, s-maxage=10, stale-while-revalidate=59',
  );

  return await getResearchConditionsPage(context);
}) satisfies GetServerSideProps<ResearchConditionsPageProps>;

export default function ResearchConditions(props: ResearchConditionsPageProps) {
  const {
    page: {
      id,
      title,
      date,
      modified,
      seo,
      acf: { hero, pageType, blocks },
    },
    /* conditionsByType: { conditions, pagination, conditionType }, */
    /* conditionsType, */
    postsList: { posts, pagination },
  } = props;

  return (
    <PageWrap seo={seo} pageType={pageType} title={title}>
      <ArticleJson id={id} date={date} modified={modified} seo={seo} />
      <Wrap className="relative !gap-y-3 lg:grid-cols-12 lg:gap-x-6 xl:gap-x-12 !mb-0 !pb-0">
        <HeroResearch hero={hero} />
        {/*         <ConditionsByType
          className="lg:col-span-full"
          conditionTypes={conditionsType}
          conditions={conditions}
          pagination={pagination}
          conditionType={conditionType}
        /> */}
      </Wrap>
      <Wrap className="relative !mb-0 !pb-0">
        <Archive posts={posts} pagination={pagination} />
      </Wrap>
      {/* <Line containerSize="large" /> */}
      {blocks && blocks.length > 0 && (
        <Blocks pageType={pageType} blocks={blocks as BlocksType[]} />
      )}
    </PageWrap>
  );
}
